module.exports = __webpack_public_path__ + "static/media/s6.75b7d6fa.png";